import { useEffect } from 'react';

import { GOOGLE_TAG_MANAGER_ID } from 'features/google-tag-manager/constants/google-tag-manager-id';
import { sendGTMEvent } from 'features/google-tag-manager/utils/send-gtm-event';

const GTM_SCRIPT_ID = 'google-tag-manager-script';

const GoogleTagManager = () => {
    useEffect((): void => {
        if (!GOOGLE_TAG_MANAGER_ID) return;
        if (document.getElementById(GTM_SCRIPT_ID)) return;

        sendGTMEvent({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

        const script = document.createElement('script');
        script.id = GTM_SCRIPT_ID;
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_MANAGER_ID}`;
        document.head.appendChild(script);
    }, []);

    return null;
};

export default GoogleTagManager;
